var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyReciveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6364 16.1817C26.6364 22.7053 21.3418 27.9999 14.8182 27.9999C8.29454 27.9999 3 22.7053 3 16.1817C3 9.65807 8.29454 4.36353 14.8182 4.36353",
    stroke: "white",
    strokeWidth: 2.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3574 18.6033C11.3574 19.9455 12.3952 21.0249 13.6683 21.0249H16.2696C17.3766 21.0249 18.2761 20.0839 18.2761 18.9078C18.2761 17.6485 17.7225 17.1919 16.9061 16.9014L12.7412 15.4485C11.9248 15.1579 11.3713 14.715 11.3713 13.4421C11.3713 12.2798 12.2707 11.325 13.3777 11.325H15.9791C17.252 11.325 18.2899 12.4042 18.2899 13.7464",
    stroke: "white",
    strokeWidth: 2.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8184 9.95508V22.4086",
    stroke: "white",
    strokeWidth: 2.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5405 2.70451L21.156 7.08906C20.9905 7.25451 20.8251 7.58542 20.7896 7.82178L20.5533 9.49996C20.4705 10.1027 20.896 10.5281 21.4987 10.4454L23.1769 10.2091C23.4133 10.1736 23.7442 10.0081 23.9096 9.84269L28.2942 5.45815C29.0505 4.70178 29.4051 3.82724 28.2942 2.71633C27.1714 1.5936 26.2969 1.94815 25.5405 2.70451Z",
    stroke: "white",
    strokeWidth: 2.36364,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9141 3.33081C25.2922 4.66626 26.3322 5.70626 27.6559 6.07263",
    stroke: "white",
    strokeWidth: 2.36364,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyReciveIcon);
export default __webpack_public_path__ + "static/media/MoneyReciveIcon.ed671f3d9d7e6d074d03ec0bc48f468e.svg";
export { ForwardRef as ReactComponent };